import React from 'react'
import './Key_features.css'
import { useParams } from "react-router-dom";
import All_products from '../../common-components/all-products/All_products';

const Key_features = () => {
    const { id } = useParams();
    const product = All_products.find((p) => p.id === parseInt(id));

    if (!product) {
        return <h2>Product Not Found</h2>;
    }

    return (
        <>
            <section className='Key_features_sec'>
                <div className='container'>
                    <div className='titlediv'>
                        <h6 className='keyh6'>Key Features:</h6>
                    </div>

                    <div className='fetureslist'>
                        {product.features.map((feature, index) => (
                            <div className='listdiv' key={index}>
                                <h6 className="feature-title">{feature.title}</h6>
                                <p className="feature-content">{feature.content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Key_features;
